import { GxIcon } from './icon.js'



export class GxIconClock extends GxIcon {
  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock h-5 w-5" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
`
    super.addHTML(temp)
  }
}


if (!window.customElements.get("gx-icon-clock")) window.customElements.define("gx-icon-clock", GxIconClock)
